import React, { useState, useEffect, useCallback } from 'react';
import './WhyChooseUs.css';
import Lightbox from './Lightbox';

const WhyChooseUs: React.FC = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [lightboxOpen, setLightboxOpen] = useState(false);
  const [isPaused, setIsPaused] = useState(false);

  const sliderImages = [
    { src: '/images/about/etkinlik1.jpg', alt: 'Anaokulu sınıf etkinliği' },
    { src: '/images/about/etkinlik2.jpg', alt: 'Çocuklar grup çalışması yapıyor' },
    { src: '/images/about/etkinlik3.jpg', alt: 'Oyun temelli öğrenme etkinliği' },
    { src: '/images/about/etkinlik4.jpg', alt: 'Yaratıcı sanat çalışması' },
    { src: '/images/about/etkinlik5.jpg', alt: 'Okul öncesi değerler eğitimi' },
    { src: '/images/about/etkinlik6.jpg', alt: 'Anaokulu bahçe etkinliği' },
  ];

  const goToNext = useCallback(() => {
    setCurrentSlide((prev) => (prev + 1) % sliderImages.length);
  }, [sliderImages.length]);

  const goToPrev = useCallback(() => {
    setCurrentSlide((prev) => (prev - 1 + sliderImages.length) % sliderImages.length);
  }, [sliderImages.length]);

  const goToSlide = (index: number) => {
    setCurrentSlide(index);
  };

  const openLightbox = () => {
    setLightboxOpen(true);
    setIsPaused(true);
  };

  const closeLightbox = () => {
    setLightboxOpen(false);
    setIsPaused(false);
  };

  // Auto-play slider
  useEffect(() => {
    if (isPaused || lightboxOpen) return;

    const interval = setInterval(() => {
      goToNext();
    }, 4000);

    return () => clearInterval(interval);
  }, [isPaused, lightboxOpen, goToNext]);

  return (
    <section className="why-choose-section">
      <div className="why-container">
        {/* Section Title */}
        <h2 className="why-section-title">Okulumuz</h2>

        {/* Top Cards */}
        <div className="why-cards-grid">
          {/* Card 1 - Fiziki Yapı */}
          <div className="why-card">
            <div className="why-card-image">
              <img src="/images/whychoose/egitim.jpg" alt="Güvenli ve Hijyenik Ortam" />
            </div>
            <h3 className="why-card-title">Güvenli ve Hijyenik Ortam</h3>
            <p className="why-card-description">
              Fiziki yapısıyla çocuklara güvenli, hijyenik ve sıcak bir ortam sunan okulumuzda; yaş gruplarına uygun sınıflar, oyun ve etkinlik alanları bulunmaktadır.
            </p>
          </div>

          {/* Card 2 - Eğitim Kadrosu */}
          <div className="why-card">
            <div className="why-card-image">
              <img src="/images/whychoose/oyun.jpg" alt="Uzman Eğitim Kadrosu" />
            </div>
            <h3 className="why-card-title">Uzman Eğitim Kadrosu</h3>
            <p className="why-card-description">
              Alanında uzman ve sevgi dolu eğitim kadromuz, çocukların Kur'an-ı Kerim'i sevgiyle tanımalarını ve güzel ahlaki değerleri kazanmalarını hedeflemektedir.
            </p>
          </div>

          {/* Card 3 - Eğitim Modeli */}
          <div className="why-card">
            <div className="why-card-image">
              <img src="/images/whychoose/etkinlik.jpg" alt="Oyun Temelli Öğrenme" />
            </div>
            <h3 className="why-card-title">Oyun Temelli Öğrenme</h3>
            <p className="why-card-description">
              Oyun temelli öğrenme yöntemleriyle öğrenme süreçleri keyifli hale getirilirken, özgüven, sorumluluk ve paylaşma değerleri kazandırılmaktadır.
            </p>
          </div>
        </div>

        {/* Bottom Content */}
        <div className="why-bottom-content">
          {/* Left - Image Slider */}
          <div className="why-slider-section">
            <div
              className="why-slider"
              onMouseEnter={() => setIsPaused(true)}
              onMouseLeave={() => setIsPaused(false)}
            >
              <div
                className="why-slider-track"
                style={{ transform: `translateX(-${currentSlide * 100}%)` }}
              >
                {sliderImages.map((image, index) => (
                  <div key={index} className="why-slider-slide" onClick={openLightbox}>
                    <img src={image.src} alt={image.alt} />
                    <div className="why-slider-overlay">
                      <i className="fas fa-search-plus"></i>
                    </div>
                  </div>
                ))}
              </div>

              {/* Navigation Arrows */}
              <button className="why-slider-arrow why-slider-arrow-prev" onClick={goToPrev}>
                <i className="fas fa-chevron-left"></i>
              </button>
              <button className="why-slider-arrow why-slider-arrow-next" onClick={goToNext}>
                <i className="fas fa-chevron-right"></i>
              </button>

              {/* Dots */}
              <div className="why-slider-dots">
                {sliderImages.map((_, index) => (
                  <button
                    key={index}
                    className={`why-slider-dot ${currentSlide === index ? 'active' : ''}`}
                    onClick={() => goToSlide(index)}
                  />
                ))}
              </div>
            </div>
          </div>

          {/* Right - Text Content */}
          <div className="why-text-section">
            <p className="why-subtitle">Cennetin Çocukları 4-6 Yaş Grubu</p>
            <h2 className="why-title">EĞİTİM ANLAYIŞIMIZ</h2>
            <p className="why-description">
              Esenyurt İlçe Müftülüğü Albayrak Vakfı bünyesinde, 2017 yılında eğitim hayatına
              başlayan Cennetin Çocukları 4-6 yaş grubu okulumuz; Kur'an-ı Kerim ve değerler eğitimi başta
              olmak üzere, 4-6 yaş grubu çocuklarımıza yönelik manevi, sosyal, duygusal ve bilişsel
              gelişimlerini destekleyen bir eğitim modeli uygulamaktadır.
            </p>
            <p className="why-description">
              Eğitim ortamlarımız, çocukların rahatça öğrenip keşfedebileceği şekilde düzenlenmiştir.
              Cennetin Çocukları 4-6 yaş grubu okulumuz olarak, yarının bilinçli, ahlaklı ve donanımlı bireylerini
              yetiştirmek için çalışıyoruz.
            </p>
          </div>
        </div>
      </div>

      {/* Lightbox */}
      <Lightbox
        isOpen={lightboxOpen}
        imageSrc={sliderImages[currentSlide]?.src || ''}
        imageAlt={sliderImages[currentSlide]?.alt || ''}
        onClose={closeLightbox}
        onPrev={goToPrev}
        onNext={goToNext}
        hasPrev={true}
        hasNext={true}
      />

      {/* Bottom Wave */}
      <div className="why-wave-bottom">
        <svg viewBox="0 0 1440 100" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M0,50 C120,80 240,20 360,50 C480,80 600,20 720,50 C840,80 960,20 1080,50 C1200,80 1320,20 1440,50 L1440,100 L0,100 Z"
                fill="#EF7D3C" />
        </svg>
      </div>
    </section>
  );
};

export default WhyChooseUs;
